import { useMemo } from 'react';
import useInfiniteFetch from '@hooks/useInfiniteFetch';
import { getHost } from '@utils/api-helper/host';
import { unstable_serialize } from 'swr/infinite';
import { processTestSeriesData } from '@api/processors/testSeries';
import { emptyList } from '@constants/empty';

const defaultHost = getHost();

const useTestSeries = (
  goalUID,
  testType,
  options = { fallbackData: undefined, revalidateOnMount: false }
) => {
  const key = `${defaultHost}v1/uplus/subscription/test_series/?goal_uid=${goalUID}&type=${
    testType || 1
  }&limit=12`;

  const {
    data: testSeriesData,
    isValidating,
    ...rest
  } = useInfiniteFetch(
    key,
    { applyOffsetsAutomatically: false },
    {
      fallbackData: options.fallbackData ? [options.fallbackData] : undefined,
      revalidateOnMount: false,
      revalidateFirstPage: false
    }
  );

  const testSseriesProcessedData = useMemo(
    () => ({
      ...testSeriesData,
      results: testSeriesData?.results?.map(processTestSeriesData) || emptyList
    }),
    [testSeriesData]
  );

  return {
    testSeriesData: testSseriesProcessedData,
    ...rest,
    key: unstable_serialize(() => key)
  };
};

export default useTestSeries;
